import React, { useState } from 'react';
import { Header, Icon, Loader, Message } from 'semantic-ui-react';
import type { FlatPatient } from 'types';

import { useGetZendeskCommunications } from './hooks';
import ZendeskTable from './zendeskTable';
type ZendeskProps = {
  flatPatient?: FlatPatient;
};
const Zendesk: React.FC<ZendeskProps> = ({ flatPatient }) => {
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [_isRefreshLoading, setIsRefreshLoading] = useState<boolean>(false);

  const { id } = flatPatient || {};

  const { communicationsData, communicationsError, communicationsMutate, isLoading } = useGetZendeskCommunications({
    patientId: id,
  });

  const handleErrorMessage = (errorString: string) => {
    setErrorMessage(errorString);
  };

  const _handleRefresh = async () => {
    setIsRefreshLoading(true);

    await communicationsMutate();

    setIsRefreshLoading(false);
  };
  return (
    <div>
      <Header as="h3" color="blue">
        <Icon name="ticket" size="mini" color="blue" />
        <Header.Content>Zendesk Communications</Header.Content>
      </Header>
      {isLoading && <Loader active inline="centered" />}
      {communicationsData && !communicationsData.entry && (
        <Message content="No Zendesk communications found." header="Info" warning />
      )}
      {errorMessage && (
        <Message content={errorMessage} onDismiss={() => handleErrorMessage('')} negative size="small" />
      )}
      {communicationsError && !isLoading && (
        <Message negative>
          <Message.Header>Oops! Something went wrong.</Message.Header>
          <p>{communicationsError}</p>
        </Message>
      )}
      {communicationsData && communicationsData.entry && !isLoading && (
        <ZendeskTable
          debugCommunications={communicationsData}
          communicationsMutate={communicationsMutate}
          handleErrorMessage={handleErrorMessage}
        />
      )}
    </div>
  );
};

export default Zendesk;
